<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
    >
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <p>产品ID：{{ row.productId }} </p>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">
              容量：{{ row.capacity }}{{ row.unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{
          row.code
        }}</span>
      </template>
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="examine(row)"
          v-hasPermission="'warehouse-sample-manage/sample-feedback-result'"
          >反馈采用结果</el-button
        >
      </template>
    </CommonTable>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="是否采用" prop="isUse">
          <DictSelect
            type="cml_common_whether"
            :value="ruleForm.isUse"
            @change-emit="isUseChange"
          />
        </el-form-item>
        <el-form-item v-if="ruleForm.isUse === 'NO'" label="理由" prop="reason">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            maxlength="30"
            show-word-limit
            v-model="ruleForm.reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirmBtn" :loading="submitLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="listData" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import DictSelect from '@/components/DictSelect';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
export default {
  components: { CommonTable, SampleSearchForm, DictSelect, SampleOperationLogDialog },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      listForm: { status: 'GET' },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        {
          label: '产品名称',
          prop: 'productName',
          slotColumn: true,
          slotName: 'idSlot',
          width: 200,
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '样品类型', prop: 'sampleTypeName', width: 80 },
        { label: '申请人', prop: 'demandStaffName' },
        { label: '需求品牌', prop: 'demandBrandName' },
        { label: '用途', prop: 'purpose' },
        { label: '特殊备注', prop: 'specialRemark' },
        { label: '供应商', prop: 'supplierName' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 120,
        },
      ],
      tableDataTab: {},
      selectTab: {},
      ruleForm: {
        reason: '',
        isUse: '',
      },
      dialogVisible: false,
      rules: {
        reason: [{ required: true, message: '请输入理由', trigger: 'blur' }],
        isUse: [
          { required: true, message: '请选择是否采用', trigger: 'change' },
        ],
      },
      submitLoading: false,
      listData: {}
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight(-20);
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.sample
        .getOrderGetInfoList(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectTab = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    isUseChange(val) {
      this.ruleForm.isUse = val;
      this.ruleForm.reason = '';
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 反馈采用结果
    examine(row) {
      this.selectTab = row;
      this.dialogVisible = true;
    },
    confirmBtn() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false;
        const params = { ...this.ruleForm, ...this.selectTab };
        this.submitLoading = true;
        this.$http.sample
          .addFeedback(params)
          .then(() => {
            this.$message.success('反馈成功');
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.getList();
            this.submitLoading = false;
            this.handleClose();
          });
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
      this.ruleForm = {
        reason: '',
        isUse: '',
      };
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.listData = {
        supplierName: row.supplierName,
        list: [row],
      };
    }
  },
};
</script>

<style lang="less" scoped>
</style>
